// src/pages/PublicFlyerPage.jsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";
import useCockpitGuard from "../hooks/useCockpitGuard";

import PublicFlyer from "./PublicFlyer";

export default function PublicFlyerPage() {
  const { sector: rawSector } = useParams();
  const sector = rawSector?.toUpperCase() ?? null;

  const [flyer, setFlyer] = useState(null);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);

  const { profile: authBusiness } = useCockpitGuard();

  useEffect(() => {
    if (!sector) return;

    async function load() {
      setLoading(true);

      const { data: flyerData, error: flyerErr } = await supabase
        .from("flyers")
        .select("*")
        .eq("postcode_sector", sector)
        .order("created_at", { ascending: false })
        .limit(1);

      if (flyerErr) {
        console.error("[PublicFlyerPage] flyer_load_error", flyerErr);
        setFlyer(null);
        setSlots([]);
        setLoading(false);
        return;
      }

      const flyer = flyerData?.[0] ?? null;
      setFlyer(flyer);

      if (!flyer) {
        setSlots([]);
        setLoading(false);
        return;
      }

      const { data: slotData, error: slotErr } = await supabase
        .from("flyer_slots")
        .select(`
          id,
          flyer_id,
          slot_number,
          status,
          business_name,
          offer_title,
          offer_text,
          logo_url,
          qr_code_url,
          postcode_sector,
          redeem_token,
          category_name,
          category_color,
          category_icon
        `)
        .eq("flyer_id", flyer.id)
        .eq("postcode_sector", sector)
        .order("slot_number", { ascending: true });

      if (slotErr) {
        console.error("[PublicFlyerPage] slot_load_error", slotErr);
        setSlots([]);
      } else {
        const normalized = (slotData ?? []).map((s) => ({
          ...s,
          token: s.redeem_token || null,
        }));
        setSlots(normalized);
      }

      setLoading(false);
    }

    load();
  }, [sector]);

  if (loading) return null;

  return (
    <>
      <PublicFlyer
        sector={sector}
        flyer={flyer}
        slots={slots}
        authBusiness={authBusiness}
      />
    </>
  );
}
